import script from "./AdminUtilisateurPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUtilisateurPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__